import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable, Subject } from 'rxjs';
// Ne doit pas importer des classes issue de ce project @angular/common/http & rxjs doit etre suffisant pour cette Utilit

type AvailableMethod = 'get'|'post'|'put'|'navigate';

export class InfoConnection {

  /**
   * Pour indiquer que l'on va envoyer du json au server datasnap
   */
  get DEFAUT_HEADER_JSON_UTF8(): any {
        return {
            'Accept': 'application/json',
            'Content-Type': 'text/plain;charset=UTF-8'
        };
    }


    get DEFAUT_HEADER_OCTETSTREAM(): any {
        return {
            'Accept': 'application/octet-stream',
            'Content-Type': 'application/octet-stream'
        };
    }

    private mHttp: HttpClient;              // Service Http d'angular pour effectuer les requettes http....
    private readonly mUseHttps: boolean;
    private readonly mAdresseIp: String;    // IP cible
    private readonly mPort: String;         // Port cible
    private readonly mPath: string;         // Chemin utiliser pour effectuer la requtte

    // Utilisation de any pour httpParam & httpHeader car soucis lors de l'ajout de param sur l'header de la requete
    private mHeaderHttp: any;               // Utiliser pour editer l'entête de la requete HTTP
    private mParamsHttp: any;               //
    private mBody: any;                     // Corps de la requette que l'on envoie
    private mReponseType: any;

    // utilit pour les fonction spécifique
    public mChangePageOnNavigate: boolean;

    /**
     * Init des params de la classe
     */
    constructor(http: HttpClient,
                ipAdress: String,
                port: String,
                path: string,
                useHttps: boolean) {
        this.mHttp = http;
        this.mAdresseIp = ipAdress;
        this.mPort = port;
        this.mPath = path;
        this.mHeaderHttp = null;
        this.mChangePageOnNavigate = true;
        this.mReponseType = 'json';
        this.mUseHttps = useHttps;
    }

    // Param de la class
    // Getter & Setter
    ////////////////////

    public setCustomHeader(header: any) {
        this.mHeaderHttp = header;
    }

    public setCustomParams(params: any) {
        this.mParamsHttp = params;
    }

    public setBody(body: any) {
        this.mBody = body;
    }

    public setChangePageOnNavigate(value: boolean) {
        this.mChangePageOnNavigate = value;
    }

    public setReponseType(reponseType: 'json'|'blob') {
        this.mReponseType = reponseType;
    }

    public getUrlMethodePath(): string {
        const protocol = this.mUseHttps ? 'https' : 'http';
        return protocol + '://' + this.mAdresseIp + ':' + this.mPort + '/' + this.mPath;
    }

    // Exec des requetes
    ////////////////////

    public addToQueue(method: AvailableMethod): Subject<any> {
      return HttpQueue.getInstance().invoke(this, method);
    }

    public GETFunction<T>(): Observable<HttpResponse<T>> {
        if (!this.mHeaderHttp) this.mHeaderHttp = this.DEFAUT_HEADER_JSON_UTF8;
        return this.mHttp.get<T>(this.getUrlMethodePath(),
            {
                headers: this.mHeaderHttp,
                observe: 'response',
                params: this.mParamsHttp ? this.mParamsHttp : {},
                responseType: this.mReponseType
            }
        );
    }

    public POSTFunction<T>(): Observable<HttpResponse<T>> {
        if (!this.mHeaderHttp) this.mHeaderHttp = this.DEFAUT_HEADER_JSON_UTF8;
        return this.mHttp.post<T>(
            this.getUrlMethodePath(),
            this.mBody,
            {
                headers: this.mHeaderHttp,
                /*{
                    'Accept': 'application/json',
                    'Content-Type': 'text/plain;charset=UTF-8',
                },*/
                observe: 'response',
                params: this.mParamsHttp ? this.mParamsHttp : {},
                responseType: this.mReponseType
            }
        );
    }

    public PUTFunction<T>(): Observable<HttpResponse<T>> {
      if (!this.mHeaderHttp) this.mHeaderHttp = this.DEFAUT_HEADER_JSON_UTF8;
      return this.mHttp.put<T>(
        this.getUrlMethodePath(),
        this.mBody,
        {
          headers: this.mHeaderHttp,
          observe: 'response',
          params: this.mParamsHttp ? this.mParamsHttp : {},
          responseType: this.mReponseType
        }
      );
    }

    /**
     * Renvois vers une page web spécifique
     * On peut configurer le changement de page avec la variable { changePageOnNavigate } de la classe
     */
    public navigateTo() {
      // Ajouter des params
      let queryParamStr = '';
      if (this.mParamsHttp) {
        for (const value of Object.keys(this.mParamsHttp)) {
          // Ajout du prefix
          queryParamStr += ((queryParamStr.length === 0) ? '?' : '&');
          // Ajout du param, encodeURIComponent car on peut avoir des character spéciaux a encoder ex:'&'
          queryParamStr += value + '=' + encodeURIComponent(this.mParamsHttp[value]);
        }
      }
      const url = this.getUrlMethodePath() + queryParamStr;
      if (this.mChangePageOnNavigate)
        window.open(url);
      else
        window.location.href = url;
    }
}

export class PendingRequest {
    object: InfoConnection;
    method: AvailableMethod;
    subscription: Subject<HttpResponse<any>>;

    constructor(obj: InfoConnection, method: AvailableMethod, subscription: Subject<HttpResponse<any>>) {
        this.object = obj;
        this.method = method;
        this.subscription = subscription;
    }
}

/**
 * Singleton utilisé pour envoyé les requtte dans une file d'attente
 */
export class HttpQueue {

  private static sHTTPQueue: HttpQueue | null = null;

  public static getInstance(): HttpQueue {
    if (this.sHTTPQueue == null)
      this.sHTTPQueue = new HttpQueue();
    return this.sHTTPQueue;
  }

  private request =  new Subject<PendingRequest>();
  private queue: PendingRequest[] = [];

  constructor() {
    this.request.subscribe(request => this.execute(request));
  }



    /** Call this method to add your http request to queue */
    invoke(obj: InfoConnection, method: AvailableMethod): Subject<HttpResponse<any>> {
      return this.addRequestToQueue(obj, method);
    }

    private async execute(requestData: PendingRequest) {
        try {
            let resultRequest: HttpResponse<any> | undefined;
            switch (requestData.method) {
              case 'get':
                resultRequest = await requestData.object.GETFunction().toPromise();
                break;
              case 'post':
                resultRequest = await requestData.object.POSTFunction().toPromise();
                break;
              case 'put':
                resultRequest = await requestData.object.PUTFunction().toPromise();
                break;
              case 'navigate':
                requestData.object.navigateTo();
                resultRequest = undefined;
                break;
              default:
                console.error('Request method not handle: ' + requestData.method);
                resultRequest = undefined;
                break;
            }
            requestData.subscription.next(resultRequest);
        } catch (e) {
            requestData.subscription.error(e);
        } finally {
            // En cas de plantage on va toujours traiter la prochaine requette
            requestData.subscription.complete();
            this.queue.shift();
            this.startNextRequest();
        }
      }

    private addRequestToQueue(object: InfoConnection, method: AvailableMethod): Subject<HttpResponse<any>> {
      const sub = new Subject<HttpResponse<any>>();
      const request = new PendingRequest(object, method, sub);

      this.queue.push(request);
      if (this.queue.length === 1) {
        this.startNextRequest();
      }
      return sub;
    }

    private startNextRequest() {
      // get next request, if any.
      if (this.queue.length > 0) {
        this.execute(this.queue[0]);
      }
    }
}
